import { Checkbox } from '@material-ui/core';
import { settings } from './Settings';
//import { Math } from './Math'
import {RoundValueASTM} from './FuelMath';
export class ViscosityCalculationService {

    static response = {
        FuelConstantA: "",
        FuelConstantB: "",
        ViscosityIndex: "",
        ShellViscosityConstant: ""
    };
    
    /* static GetDecimals(settings){
        return Math.Pow(10, -1 * settings)
     } */
    static CalculateFuelConstants(config, constval) {
        let ViscosityNo1 = config.ViscosityNo1 ? parseFloat(config.ViscosityNo1) : 0;
        let TemperatureNo1 = config.TemperatureNo1 ? parseFloat(config.TemperatureNo1) : 0;
        let ViscosityNo2 = config.ViscosityNo2 ? parseFloat(config.ViscosityNo2) : 0;
        let TemperatureNo2 = config.TemperatureNo2 ? parseFloat(config.TemperatureNo2) : 0;
        //let Math.log10 = Math.log(10);
        let logLogX = Math.log10(Math.log10((ViscosityNo1) + 0.7))
        let logTx = Math.log10(273.0 + (TemperatureNo1))

        let logLogY = Math.log10(Math.log10((ViscosityNo2) + 0.7))
        let logTy = Math.log10(273.0 + (TemperatureNo2))

        let constant_A = ((logLogY * logTx) - (logLogX * logTy)) / (logTx - logTy)

        let FuelConstantA = ((RoundValueASTM((constant_A))).toFixed(3))
        let FuelConstantB = ((RoundValueASTM(((constant_A - logLogX) / logTx))).toFixed(3))

        return ({ FuelConstantA: FuelConstantA ? FuelConstantA : "", FuelConstantB: FuelConstantB ? FuelConstantB : "" })

    }
    
    static CalculateViscosity(config, constval) {
        let ViscosityNo1 = config.ViscosityNo1 ? parseFloat(config.ViscosityNo1) : 0;
        let TemperatureNo1 = config.TemperatureNo1 ? parseFloat(config.TemperatureNo1) : 0;
        let ViscosityNo2 = config.ViscosityNo2 ? parseFloat(config.ViscosityNo2) : 0;
        let TemperatureNo2 = config.TemperatureNo2 ? parseFloat(config.TemperatureNo2) : 0;
        let fuelConstantB = constval.FuelConstantB ? +constval.FuelConstantB : 0;

        //let Math.log10 = Math.log(10);
        let logLogX = Math.log10(Math.log10((ViscosityNo1) + 0.7))
        let logTx = Math.log10(273.0 + (TemperatureNo1))
        let logTy = Math.log10(273.0 + (TemperatureNo2))
        let CalculatedViscosity = Math.pow(
            10,
            (Math.pow(
                10,
                (logLogX + (fuelConstantB * logTx) - (fuelConstantB * logTy)))
            )) - 0.7

        return CalculatedViscosity;
    }

    static CalculateViscosityIndex(config, constval) {
        //let Math.log10 = Math.log(10);
        let VIC = [
            [2.0, 3.8, 1.14673, 1.7576, -0.109, 0.84155, 1.5521, -0.077],
            [3.8, 4.4, 3.38095, -15.4952, 33.196, 0.78571, 1.7929, -0.183],
            [4.4, 5.0, 2.5, -7.2143, 13.812, 0.82143, 1.5679, 0.119],
            [5.0, 6.4, 0.101, 16.635, -45.469, 0.04985, 9.1613, -18.557],
            [6.4, 7.0, 3.35714, -23.5643, 78.466, 0.22619, 7.7369, -16.656],
            [7.0, 7.7, 0.01191, 21.475, -72.87, 0.79762, -0.7321, 14.61],
            [7.7, 9.0, 0.41858, 16.1558, -56.04, 0.05794, 10.5156, -28.24],
            [9.0, 12, 0.88779, 7.5527, -16.6, 0.26665, 6.7015, -10.81],
            [12, 15, 0.7672, 10.7972, -38.18, 0.20073, 8.4658, -22.49],
            [15, 18, 0.97305, 5.3135, -2.2, 0.28889, 5.9741, -4.93],
            [18, 22, 0.97256, 5.25, -0.98, 0.24504, 7.416, -16.73],
            [22, 28, 0.91413, 7.4759, -21.82, 0.20323, 9.1267, -34.23],
            [28, 40, 0.87031, 9.7157, -50.77, 0.18411, 10.1015, -46.75],
            [40, 55, 0.84703, 12.6752, -133.31, 0.17029, 11.4866, -80.62],
            [55, 70, 0.85921, 11.1009, -83.19, 0.1713, 11.368, -76.94],
            [70, 1000, 0.83531, 14.6731, -216.246, 0.16841, 11.8493, -96.947]
        ];
        let ViscosityNo1 = config.ViscosityNo1 ? parseFloat(config.ViscosityNo1) : 0;
        let TemperatureNo1 = config.TemperatureNo1 ? parseFloat(config.TemperatureNo1) : 0;
        let ViscosityNo2 = config.ViscosityNo2 ? parseFloat(config.ViscosityNo2) : 0;
        let TemperatureNo2 = config.TemperatureNo2 ? parseFloat(config.TemperatureNo2) : 0;
        let temp2 = ""
        let visc40 = 0
        let visc100 = 0
        let minY = 0
        let maxY = 1
        let A = 2
        let B = 3
        let C = 4
        let D = 5
        let E = 6
        let F = 7
        let n = ""
        let L = ""
        let H = ""
        //let k = ""

        if (TemperatureNo1 !== 40 || TemperatureNo2 !== 100) {
            let constval = this.CalculateFuelConstants(config)
            temp2 = TemperatureNo2
            config.TemperatureNo2 = "40"
            //this.CalculateViscosity()
            visc40 = this.CalculateViscosity(config, constval)
            config.TemperatureNo2 = "100"
            //this.CalculateViscosity()
            visc100 = this.CalculateViscosity(config, constval)
            config.TemperatureNo2 = temp2
        } else {
            visc40 = (ViscosityNo1)
            visc100 = (ViscosityNo2)
        }


        for (let k = 0; k < 16; k++) {
            if (k < 16 && visc100 >= VIC[k][minY] && visc100 <= VIC[k][maxY]) {
                L = (VIC[k][A] * (visc100) ** 2) + (VIC[k][B] * visc100) + VIC[k][C]
                H = (VIC[k][D] * (visc100) ** 2) + (VIC[k][E] * visc100) + VIC[k][F]
                break;
            }
            else if (k == 16 && visc100 >= VIC[k][minY]) {
                L = (VIC[k][A] * (visc100) ** 2) + (VIC[k][B] * visc100) + VIC[k][C]
                H = (VIC[k][D] * (visc100) ** 2) + (VIC[k][E] * visc100) + VIC[k][F]
            }
        }
        
        if (L===""&& H===""){
            return "";
        }else{
        if (visc40 >= H) {
            this.ViscosityIndex = ((RoundValueASTM(((L - visc40) / (L - H)) * 100)).toFixed(2))
        } else {
            n = (Math.log10(H) - Math.log10(visc40)) / Math.log10(visc100)
            this.ViscosityIndex = ((RoundValueASTM((((10 ** n) - 1) / 0.00715) + 100)).toFixed(2))
        }
    }
        return ({ ViscosityIndex: this.ViscosityIndex ? this.ViscosityIndex : "" })

    }


    static CalculateViscTemp(service,layout,checked) {
        let ViscosityNo1 = service.ViscosityNo1 ? parseFloat(service.ViscosityNo1) : 0;
        let TemperatureNo1 = service.TemperatureNo1 ? parseFloat(service.TemperatureNo1) : 0;
        let ViscosityNo2 = service.ViscosityNo2 ? parseFloat(service.ViscosityNo2) : 0;
        let TemperatureNo2 = service.TemperatureNo2 ? parseFloat(service.TemperatureNo2) : 0;

        let FuelConstantA,FuelConstantB
        if(checked===true){
            FuelConstantA=layout.FuelConstantA
            FuelConstantB=layout.FuelConstantB
        }
        else {
            FuelConstantA=settings.FuelConstantA
            FuelConstantB=settings.FuelConstantB
        }
        
        if (service.calcType === 10) {
            let calcViscosity=this.CalculateViscosity1(service,layout,FuelConstantA,FuelConstantB);
            this.ViscosityNo2 = ((RoundValueASTM(calcViscosity,0.1)).toFixed(2))
            return this.ViscosityNo2;
        } else if (service.calcType === 20) {
            let calcTemperature=this.CalculateTemperature(service,layout,FuelConstantA,FuelConstantB);
            this.TemperatureNo2 = ((RoundValueASTM(calcTemperature,0.1)).toFixed(2))
            return this.TemperatureNo2;
        }

    }
    
    static CalculateViscosity1(service,layout,FuelConstantA,FuelConstantB) {
        let ViscosityNo1 = service.ViscosityNo1 ? parseFloat(service.ViscosityNo1) : 0;
        let TemperatureNo1 = service.TemperatureNo1 ? parseFloat(service.TemperatureNo1) : 0;
        let ViscosityNo2 = service.ViscosityNo2 ? parseFloat(service.ViscosityNo2) : 0;
        let TemperatureNo2 = service.TemperatureNo2 ? parseFloat(service.TemperatureNo2) : 0;
        //let Math.log10 = Math.log(10);
        let logLogX = Math.log10(Math.log10((ViscosityNo1) + 0.7))
        let logTx = Math.log10(273.0 + (TemperatureNo1))
        let logTy = Math.log10(273.0 + (TemperatureNo2))
        let CalculatedViscosity = ((10 ** (10 ** (logLogX + ((FuelConstantB) * logTx) - ((FuelConstantB) * logTy)))) - 0.7)
        return CalculatedViscosity;
    }
    static CalculateTemperature(service,layout,FuelConstantA,FuelConstantB) {
        let ViscosityNo1 = service.ViscosityNo1 ? parseFloat(service.ViscosityNo1) : 0;
        let TemperatureNo1 = service.TemperatureNo1 ? parseFloat(service.TemperatureNo1) : 0;
        let ViscosityNo2 = service.ViscosityNo2 ? parseFloat(service.ViscosityNo2) : 0;
        let TemperatureNo2 = service.TemperatureNo2 ? parseFloat(service.TemperatureNo2) : 0;

        let logLogX = Math.log10(Math.log10((ViscosityNo1) + 0.7))
        let logTx = Math.log10(273.0 + (TemperatureNo1))
        let logLogY = Math.log10(Math.log10((ViscosityNo2) + 0.7))
        let CalculatedTemperature = ((RoundValueASTM((10 ** (((logLogX - logLogY) / (FuelConstantB)) + logTx)) - 273.0)).toFixed(2))
        return CalculatedTemperature;
    }
    static CalculateShellViscosityConstant(config, constval) {
        
        let ViscosityNo1 = config.ViscosityNo1 ? parseFloat(config.ViscosityNo1) : 0;
        let TemperatureNo1 = config.TemperatureNo1 ? parseFloat(config.TemperatureNo1) : 0;
        let ViscosityNo2 = config.ViscosityNo2 ? parseFloat(config.ViscosityNo2) : 0;
        let TemperatureNo2 = config.TemperatureNo2 ? parseFloat(config.TemperatureNo2) : 0;
        //let Math.log10 = Math.log(10);
        let X = (ViscosityNo1) + 0.85
        let logX = Math.log10(X)
        let loglogX = Math.log10(logX)
        let Y = (ViscosityNo2) + 0.85
        let logY = Math.log10(Y)
        let loglogY = Math.log10(logY)
        let L = (33.5 * loglogX - 33.5 * loglogY)
        let ShellViscosityConstant = ((RoundValueASTM(L / (Math.log10((273 + (TemperatureNo2)) / (273 + (TemperatureNo1)))))).toFixed(2))
        return ({ ShellViscosityConstant: ShellViscosityConstant ? ShellViscosityConstant : "" })
    }
    static MinimumDetails(){
        
    }
}
